// tslint:disable

import React, {Component, useContext, useEffect} from 'react'

import loadScript from 'simple-load-script'

const currentUrl = () => location.pathname + location.search

export type TrackingContextType = {
	url: string
	title: string
}
export const TrackingContext = React.createContext<{
	url: string
	title: string
}>(null)

export const Tracker: React.FC<{
	children: (api?: {url: string; title: string}) => void
}> = ({children}) => {
	const context = useContext(TrackingContext)
	useEffect(() => {
		children(context)
	}, [context.url])
	return null
}

declare global {
	interface Window {
		gtag: (...args: Array<any>) => void
		dataLayer: Array<any>
	}
}
declare var gtag: (...args: Array<any>) => void
declare var dataLayer: Array<any>

export class GATracking extends Component<{
	id: string
	acceptedCookies: boolean
}> {
	constructor(props) {
		super(props)
		const {id, acceptedCookies} = this.props
		loadScript(`https://www.googletagmanager.com/gtag/js?id=${id}`)
		window.dataLayer = window.dataLayer || []
		window.gtag = function() {
			window.dataLayer.push(arguments)
		}
		gtag('js', new Date())
		gtag('config', id, {anonymize_ip: !acceptedCookies})
	}

	render() {
		const {acceptedCookies} = this.props
		return (
			<Tracker>
				{({url, title}) =>
					gtag('eventresource.tsx', 'page_view', {
						page_path: url,
						page_title: title,
						anonymize_ip: !acceptedCookies
					})
				}
			</Tracker>
		)
	}
}

export class GTMTracking extends Component<{
	id: string
	acceptedCookies: boolean
}> {
	constructor(props) {
		super(props)
		const {id} = this.props
		loadScript(`https://www.googletagmanager.com/gtm.js?id=${id}&l=dataLayer`)
		window.dataLayer = window.dataLayer || []
		dataLayer.push({
			'gtm.start': new Date().getTime(),
			event: 'gtm.js'
		})
	}

	render() {
		const {acceptedCookies} = this.props
		return (
			<Tracker>
				{({url, title}) =>
					dataLayer.push({
						event: 'VirtualPageview',
						virtualPageURL: url,
						virtualPageTitle: title,
						anonymize_ip: !acceptedCookies
					})
				}
			</Tracker>
		)
	}
}

declare global {
	interface Window {
		fbq: any
	}
}
declare var fbq: any

export class FBPTracking extends Component<{
	id: string
	acceptedCookies: boolean
}> {
	loaded = false
	render() {
		const {id, acceptedCookies} = this.props
		if (this.loaded || !acceptedCookies) return
		this.loaded = true
		loadScript('https://connect.facebook.net/en_US/fbevents.js').catch(
			error => {
				console.info(error)
			}
		)
		window.fbq = function() {
			fbq.callMethod
				? fbq.callMethod.apply(fbq, arguments)
				: fbq.queue.push(arguments)
		}
		fbq.loaded = true
		fbq.version = '2.0'
		fbq.queue = []
		fbq('init', id)
		fbq('track', 'PageView')
		return null
	}
}
